import { useMemo } from "react";
import { useHosts, useRoles } from "../api/queries";
import type { Role } from "../api/models";
import { readClaims, roleIdsOf, type TokenClaims } from "./token";

// PORT OF `AuthService.HasRole`: THE ROLE GROUP NAMES A ROLE ROW, AND THE TOKEN'S
// `roles` CLAIM LISTS THE ROLE IDS THE USER HOLDS
export function hasRole(group: string, roles: Role[], claims: TokenClaims | null): boolean {
  const role = roles.find((r) => r.group === group);
  if (!role) return false;
  return roleIdsOf(claims).includes(role.ID.toFixed());
}

export function useSession() {
  const claims = readClaims();
  const roles = useRoles();
  const hosts = useHosts();

  return useMemo(() => {
    const roleList = roles.data ?? [];
    const hostUser = hosts.data?.find((h) => h.userId === claims?.userId) ?? null;
    return {
      userId: claims?.userId ?? null,
      hostUser,
      // ROLE CHECKS ARE ONLY ANSWERABLE ONCE ROLES HAVE LOADED. CALLERS MUST WAIT
      // ON `ready` RATHER THAN READ `false` AS "NOT PERMITTED" (SEE #87'S RACE).
      ready: roles.isSuccess && hosts.isSuccess,
      error: roles.error ?? hosts.error,
      hasRole: (group: string) => hasRole(group, roleList, claims),
    };
    // CLAIMS ARE RE-READ FROM STORAGE EACH RENDER; KEY THE MEMO ON WHAT THEY SAY
  }, [roles.data, roles.isSuccess, roles.error, hosts.data, hosts.isSuccess, hosts.error, claims?.userId, claims?.roles]);
}
